// @flow
export const REQUEST = 'auth/REQUEST'
export const SUCCESS = 'auth/SUCCESS'
export const ERROR = 'auth/ERROR'

const initialState = {
  authenticated: false,
  authError: ''
}

export const authenticationRequest = (username, password) => {
  return {
    type: REQUEST,
    payload: {
      username,
      password
    }
  }
}

export const authenticationSuccess = () => {
  return {
    type: SUCCESS
  }
}

export const authenticationError = () => {
  return {
    type: ERROR
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        authenticated: false
      }
    case SUCCESS:
      return {
        ...state,
        authenticated: true
      }
    case ERROR:
      return {
        ...state,
        authError: 'Incorrect username and/or password',
        authenticated: false
      }
    default:
      return state
  }
}

export default reducer
export * from './saga'



// WEBPACK FOOTER //
// ./src/ducks/auth/index.js